import React from 'react';
import { FileText, ArrowLeft } from 'lucide-react';

const TermsOfService: React.FC = () => {
  return (
    <div className="min-h-screen bg-slate-950 text-slate-200 p-4 md:p-8">
      <div className="max-w-4xl mx-auto">
        <a href="/" className="inline-flex items-center gap-2 text-blue-400 hover:text-blue-300 mb-8 transition-colors">
          <ArrowLeft className="w-4 h-4" />
          Back to Application
        </a>
        
        <div className="bg-slate-900 border border-slate-800 rounded-2xl p-8 md:p-12 shadow-xl">
          <div className="flex items-center gap-4 mb-8 border-b border-slate-800 pb-8">
            <div className="p-3 bg-blue-500/10 rounded-xl">
              <FileText className="w-8 h-8 text-blue-400" />
            </div>
            <div>
              <h1 className="text-3xl font-bold text-white">Terms of Service</h1>
              <p className="text-slate-400 mt-1">Last updated: {new Date().toLocaleDateString()}</p>
            </div>
          </div>
          
          <div className="prose prose-invert max-w-none prose-slate">
            <p>
              Welcome to Celeritas Spectrometry Suite. By accessing or using this application, you agree to be bound by these Terms of Service. If you disagree with any part of the terms, you may not access the service.
            </p>

            <h2 className="text-xl font-semibold text-white mt-8 mb-4">1. Educational and Research Use</h2>
            <p>
              Celeritas is designed as an educational and research-oriented physics simulation tool. The data, visualizations, and metrics provided by this application are estimations based on theoretical models and should not be used for mission-critical engineering, medical dosimetry, or safety-critical applications without independent verification.
            </p>

            <h2 className="text-xl font-semibold text-white mt-8 mb-4">2. Intellectual Property</h2>
            <p>
              The application's interface, original graphics, and core logic are protected by copyright and other intellectual property laws. You may use the software for personal, academic, or professional research purposes as permitted by the application's open-source license.
            </p>

            <h2 className="text-xl font-semibold text-white mt-8 mb-4">3. Third-Party AI Integrations</h2>
            <p>
              Our application allows you to connect to third-party AI APIs (like OpenAI) using your own API keys. You are solely responsible for compliance with the terms of service of those third-party providers and for any costs incurred through their usage.
            </p>

            <h2 className="text-xl font-semibold text-white mt-8 mb-4">4. Disclaimer of Warranties</h2>
            <p>
              The service is provided on an "AS IS" and "AS AVAILABLE" basis. We make no warranties, expressed or implied, regarding the accuracy, reliability, or completeness of the physics simulations or any output generated by the application.
            </p>

            <h2 className="text-xl font-semibold text-white mt-8 mb-4">5. Limitation of Liability</h2>
            <p>
              In no event shall the developers of Celeritas be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or relating to your use of the application or its simulation results.
            </p>

            <div className="mt-12 p-6 bg-slate-800/50 rounded-xl border border-slate-700">
              <p className="m-0 text-slate-300">
                These terms may be updated from time to time. Continued use of the application after any changes constitutes your acceptance of the new terms.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
